import { jsx as _jsx } from "react/jsx-runtime";
import { Tag, Tooltip } from "antd";
import { useTranslation } from "../../../../../others/i18n.js";
import { getTemplateMetaDataVersionUpdateStateColor, getTemplateMetaDataVersionUpdateStateIcon, getTooltipTemplateMetaDataVersionUpdateState, getTranslationTemplateMetaDataVersionUpdateState } from "../../../../../util/release-version-state.js";
const TemplateMetaDataVersionUpdate = ({ status })=>{
    const { t } = useTranslation();
    const tooltipTitle = getTooltipTemplateMetaDataVersionUpdateState(status, t);
    const tagText = getTranslationTemplateMetaDataVersionUpdateState(status, t);
    const tagIcon = getTemplateMetaDataVersionUpdateStateIcon(status);
    const tagColor = getTemplateMetaDataVersionUpdateStateColor(status);
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: tooltipTitle,
        placement: "bottom",
        children: /*#__PURE__*/ _jsx(Tag, {
            color: tagColor,
            icon: tagIcon,
            style: {
                width: "6rem",
                textAlign: "center"
            },
            children: tagText
        })
    });
};
export { TemplateMetaDataVersionUpdate };
